// extracted by mini-css-extract-plugin
module.exports = {"endBanner":"EndBanner_endBanner__2dedZ"};